export default {
  filterDefinition: state => state.filterDefinition || [],
};
